export default __webpack_public_path__ + "static/media/C58-Light.77a6e517.png";